
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro",
      function () {
        return require("private-next-pages/pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro"])
      });
    }
  